import React from "react";
import "./offer-banner.m.css";

import { useOfferBanner } from "./utils";

export const OfferBanner = ({ config, onVisibilityChange, className }) => {
  const { isVisible, timeLeft } = useOfferBanner(config);

  React.useEffect(() => {
    if (onVisibilityChange) {
      onVisibilityChange(isVisible);
    }
  }, [isVisible, onVisibilityChange]);

  if (!isVisible) return null;

  return (
    <div styleName="bannerContainer" className={className}>
      <div styleName="textContainer">
        {config.banner_icon && (
          <span styleName="bannerIcon">{config.banner_icon}</span>
        )}
        <span styleName="bannerText">
          {config.banner_text}
        </span>
        <span styleName="bannerSubtext">
          {config.banner_subtext}
        </span>
      </div>

      {config.show_timer && timeLeft && (
        <div styleName="timerContainer">
          {Object.keys(timeLeft).map((unit) => (
            <div key={unit} styleName="timeBox">
              <span styleName="timeNumber" suppressHydrationWarning>
                {timeLeft[unit]}
              </span>
              <span styleName="timeLabel">
                {unit[0]}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
